// For Production
export const ApiUrl = "https://cms.uacind.org/api";

// For Development
// export const ApiUrl = "http://localhost:8000/api";